import { Component, Element, h, State } from '@stencil/core';

const COMPONENT_NAME = 'call-to-action-type-11';

/**
 * @slot heading - {required}, <me-heading variant="2">
 * @slot description - {required}, <me-text>
 * @slot background - <me-video lazy="true">, <me-picture lazy="true">
 * @slot action-primary - {required}, <form-sign-up-type-1 mobile-layout="stacked" textAlign="center">, <me-button variant="primary">
 * @slot action-secondary - <me-button variant="secondary">
 */

@Component({
  tag: 'call-to-action-type-11',
  styleUrl: 'index.scss',
  shadow: false,
})
export class CallToActionType11 {
  @Element() el!: HTMLElement;
  @State() hasBackground: boolean = false;
  @State() hasActionSecondary: boolean = false;

  componentDidLoad() {
    this.hasBackground = !!this.el.querySelector('[slot="background"]');
    this.hasActionSecondary = !!this.el.querySelector('[slot="action-secondary"]');
  }

  render() {
    return (
      <me-section class={{ [COMPONENT_NAME]: true, 'with-bg': this.hasBackground }} yGap="2xl" yGapLg="5xl" role="region" aria-label="Call to Action">
        <me-row yGapLg="none" yGap="none" xGapLg="none" xGap="none" justify="center" justifyLg="center" class={`${COMPONENT_NAME}__content`}>
          <div class={`${COMPONENT_NAME}__media`}>
            <slot name="background"></slot>
            <div class={`${COMPONENT_NAME}__overlay`}></div>
          </div>
          <me-column spanMd="8" span="12" class={`${COMPONENT_NAME}__intro`}>
            <slot name="heading"></slot>
            <slot name="description"></slot>
            <me-row xGap="md" xGapLg="md" yGap="md" yGapLg="md" justify="center" justifyLg="center">
              <me-column span="auto">
                <slot name="action-primary"></slot>
              </me-column>
              <me-column span="auto" class={this.hasActionSecondary ? '' : 'me-column--hidden'}>
                <slot name="action-secondary"></slot>
              </me-column>
            </me-row>
          </me-column>
        </me-row>
      </me-section>
    );
  }
}
